<template>
<div class="chapter">
<div class="inner_page">
<p class="title"><span>The Biology<br/>
  of Sin</span></p>
<p class="author"><span>Grace, Hope, and Healing<br/>
  for Those Who Feel Trapped</span></p>
<p class="author"><span>Matthew S. Stanford, Ph.D.</span></p>
<p class="imagea"><img alt="image" class="svg" src="Images/IVP_Books_Quarter.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?b6249f54